'use client'
import Maintenance from '@/components/common/Maintenance'
import { useReportCommonError } from '@l2p/swr-hooks'
import { useEffect } from 'react'

declare global {
  interface Window {
    newrelic?: {
      noticeError?: (err: Error, customAttributes?: Record<string, any>) => void
      addPageAction?: (name: string, attributes?: Record<string, any>) => void
      setCustomAttribute?: (name: string, value: any) => void
    }
  }
}

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const { reportCommonError } = useReportCommonError()

  useEffect(() => {
    reportCommonError({
      errorMessage: `MESSAGE: ${error?.message} | DIGEST: ${
        error?.digest ?? ''
      } | STACK: ${error?.stack}`,
      errorName: error?.name,
      reqUrl: typeof window !== 'undefined' ? window?.location?.href : '',
    })
    /*eslint-disable-next-line*/
  }, [])

  return (
    <html>
      <body>
        <Maintenance />
      </body>
    </html>
  )
}
